import { render, staticRenderFns } from "./Header2.vue?vue&type=template&id=679503af&scoped=true&"
import script from "./Header2.vue?vue&type=script&lang=js&"
export * from "./Header2.vue?vue&type=script&lang=js&"
import style0 from "./Header2.vue?vue&type=style&index=0&id=679503af&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679503af",
  null
  
)

export default component.exports